import type { GetPreview } from "../types";

export const getPreview: GetPreview<"PageContentWidgetAgenda"> = (widget) => {
  return widget;
};
